import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";

const RestaurantMenuLayout = () => {
  return (
    <>
    <div>
        <Sidebar />
        <Outlet />
    </div>
    </>
  );
};
export default RestaurantMenuLayout;
